export default {
  DRAGGABLE_BORDER_WIDTH: 3,
  ESCAPE_CODE: 'Escape',
};
